// utils/formatearFecha.js
export function formatearFechaMySQL(fecha) {
  if (!fecha) return "";

  // Si viene en formato MySQL con espacio, convertir a formato ISO válido
  const fechaISO = fecha.includes(" ") ? fecha.replace(" ", "T") : fecha;

  const date = new Date(fechaISO);

  if (isNaN(date)) return ""; // Si la fecha es inválida

  const fechaFormateada = date.toLocaleDateString("es-MX", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const horaFormateada = date.toLocaleTimeString("es-MX", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  return `${fechaFormateada} ${horaFormateada}`;
}
